export const awsConfiguration = {
  host: process.env.VUE_APP_IOT_ENDPOINT || '',
  apiVersion: process.env.VUE_APP_API_VERSION || 'Local',
  apiKey: 'AIzaSyDa6ZFf53TRQWAUad0vTl-2HZ5Hn82pf2c'
};

// API Gateway URL is now injected at build time via environment variables
// Old hardcoded values (kept for reference):
// Beta: 'https://hyxzsyf3z1.execute-api.eu-west-3.amazonaws.com/beta',
// Prod: 'https://rvmh0ozyxb.execute-api.eu-west-3.amazonaws.com/prod',
// RC: 'https://vjdmz8v2tj.execute-api.eu-west-3.amazonaws.com/rc'
export const AppConfig = {
  Beta: process.env.VUE_APP_API_GATEWAY_URL || '',
  Prod: process.env.VUE_APP_API_GATEWAY_URL || '',
  RC: process.env.VUE_APP_API_GATEWAY_URL || ''
};
